import React, { createContext, useContext, useCallback } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';

const AuthorizationContext = createContext();

export function useAuthorization() {
  return useContext(AuthorizationContext);
}

export function AuthorizationProvider({ children }) {

  // Função auxiliar para obter o token de autorização
  const getAccessToken = () => {
    return localStorage.getItem('accessToken');
  };

  // Listar autorizações pendentes para Disciplina
  const listAuthorizations = useCallback(async (type, extraParams = {}) => {
    const accessToken = getAccessToken();
    if (!accessToken) {
      toast.error('Realize novo login');
      return [];
    }

    // Define o parâmetro de filtro com base no tipo
    const params = {};
    if (type === "discipline") {
      params.discipline_authorization = "Sem resposta";
    } else if (type === "social_worker") {
      params.social_worker_authorization = "Sem resposta";
    }

    const mergedParams = {
      ...params,
      ...(extraParams && typeof extraParams === 'object' ? extraParams : {}),
    };

    try {
      const response = await api.get('/internals/authorization/', {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: mergedParams,
      });

      return response.data;
    } catch (error) {
      console.error("🚨 Erro ao buscar autorizações:", error);
      return [];
    }
  }, []);


  // Buscar detalhes de uma solicitação de Disciplina
  const getAuthorizationDetails = useCallback(async (id) => {
    const accessToken = getAccessToken();
    if (!accessToken) {
      toast.error('Realize novo login');
      return null;
    }

    try {
      const response = await api.get(`/internals/authorization/detail/${id}/`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return response.data;
    } catch (error) {
      toast.error('Erro ao carregar detalhes da autorização');
      return null;
    }
  }, []);


  // Atualizar autorização  (aceitar/recusar)
  const updateDisciplineAuthorization = useCallback(async (id, action, motive) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      toast.error('Token de acesso não encontrado.');
      return;
    }

    const data = {
      discipline_authorization: action,
      discipline_motive: motive,
    };

    console.log("📌 [DISCIPLINA] Dados enviados:", data);

    try {
      const response = await api.patch(`/internals/authorization/response/${id}/`, data, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      toast.success('Autorização de disciplina atualizada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('🚨 [DISCIPLINA] Erro ao atualizar autorização:', error);
      console.error('📌 [DISCIPLINA] Resposta do servidor:', error.response?.data);
      toast.error(error.response?.data?.message || 'Erro ao autorizar disciplina');
    }
  }, []);

  const updateSocialWorkerAuthorization = useCallback(async (id, action, motive) => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      toast.error('Token de acesso não encontrado.');
      return;
    }

    const data = {
      social_worker_authorization: action,
      social_worker_motive: motive,
    };

    console.log("📌 [SERVIÇO SOCIAL] Dados enviados:", data);

    try {
      const response = await api.patch(`/internals/authorization/response/${id}/`, data, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      toast.success('Autorização de serviço social atualizada com sucesso!');
      return response.data;
    } catch (error) {
      console.error('🚨 [SERVIÇO SOCIAL] Erro ao atualizar autorização:', error);
      console.error('📌 [SERVIÇO SOCIAL] Resposta do servidor:', error.response?.data);
      toast.error(error.response?.data?.message || 'Erro ao autorizar serviço social');
    }
  }, []);



  return (
    <AuthorizationContext.Provider
      value={{
        listAuthorizations,
        getAuthorizationDetails,
        updateSocialWorkerAuthorization,
        updateDisciplineAuthorization
      }}
    >
      {children}
    </AuthorizationContext.Provider>
  );
}
